export const CUSTOM_DATE_FORMAT = {
  parse: {
    dateInput: "dd.MM.yyyy",
  },
  display: {
    dateInput: "dd.MM.yyyy",
    monthYearLabel: "MMMM yyyy",
    dateA11yLabel: "d. MMMM yyyy",
    monthYearA11yLabel: "MMMM yyyy",
  },
};
